import Structure from '../modules/structure';

/**
 * Back to top script
 * @returns {jQuery} 
 */
$.fn.sideMenuSelect = function() {
    /**
     * @type {jQuery} - all containers affected by selector
     */
    var jqAllAffectedContainers = this;
   
    jqAllAffectedContainers.each(function() {
       const container = $(this);
       const structure = new Structure('ratingField', container, {
            menuElement: ".details-menu-nav",
            menuItems: {
                selector: '.details-menu-nav nav ul li>a',
                many: true
            },
            containerItems: {
                selector: '.details-contains .details-section',
                many: true
            }
        }).structure;
        const viewportHeight = window.innerHeight;

        function selectClosesSectionMenuItem(sectionID) {
            const sectionIDasHref = `#${sectionID}`;
            structure.menuItems.removeClass('current');
            structure.menuItems.each(function() {
                const menuItem = $(this);
                const menuItemHref = menuItem.attr('href');
                if (sectionIDasHref == menuItemHref) {
                    menuItem.addClass('current');
                }
            });
        }

        function getClosestSection() {
            let closesetSection = structure.containerItems[0];
            let minimalTopDifferenceBetweenContainerAndMenu = 99999;
            const menuElementViewportOffset = structure.menuElement.get(0).getBoundingClientRect();
            structure.containerItems.each(function() {
                const containerItem = $(this);
                const containerItemViewportOffset = containerItem.get(0).getBoundingClientRect();
                const currentTopDifferenceBetweenContainerAndMenu = Math.abs(containerItemViewportOffset.top - menuElementViewportOffset.top);
                if (currentTopDifferenceBetweenContainerAndMenu < minimalTopDifferenceBetweenContainerAndMenu) {
                    minimalTopDifferenceBetweenContainerAndMenu = currentTopDifferenceBetweenContainerAndMenu;
                    closesetSection = containerItem;
                }
            });

            return closesetSection;
        }

        $(window).on('scroll load', function(){
            const closestSection = getClosestSection();
            selectClosesSectionMenuItem(closestSection.attr('id'));
        })
    });

    return jqAllAffectedContainers;
};

document.addEventListener('DOMContentLoaded', function() {
    $('.menu-by-container-select-js').sideMenuSelect();
});
